import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'underscore';
import { map, pipe } from 'rxjs';
import { AlertsValidationFilter } from '../../interfaces/alerts-validation-filter.interface';
import API_URL from '../../utils/api-url-homolog';

@Injectable({
  providedIn: 'root'
})
export class AlertValidationFilterOptionsService {

  constructor(private http: HttpClient) { }

  async getUsersOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/users/list`).toPromise();
  }


  async getDetectedClassesOptions(): Promise<any[]> {
    const filterPayload = {
      layerType: "Originais"
    }
    return this.http.post<any>(`${API_URL}/alert/classes/list/`, filterPayload).toPromise();
  }

  async getValidatedClassesOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/validatedclasses/list`).toPromise();
  }

  async getTerritoryInserctionsOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/territory/list`).toPromise();
  }

  async getCitiesOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/cities/list`).toPromise();
  }

  async getAlertsOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/alert/list`).toPromise();
  }


  async getChargableOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/fine/list`)
      .pipe(map(response => {
        response.forEach((item: { value: string; id: number; }) => {
          if (item.value == 'Sim') {
            item.id = 1;
          } else {
            item.id = 0;
          }
        })
        return response;
      }))
      .toPromise();
  }

  async getFeedbackOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/feedback/list`).toPromise()
      .then(response => {
        return response.sort((a: any, b: any) => a.id > b.id ? 1 : -1);
      })
      .then(response => {
        return response.map((a: any) => {
          a.id == 99 ? (a.id = 99) : null;
          a.id == 21 ? (a.id = 99) : null;
          return a;
        });
      })
      .then(response => {
        return _.uniq(response, (item) => item.id);
      });
  }

  async getObservationOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/observation/list`).toPromise()
    .then(response => {
      return response.sort((a: any, b: any) => a.id > b.id ? 1 : -1);
    })
    .then(response => {
      return response.map((a: any) => {
        a.id == 99 ? (a.id = 99) : null;
        a.id == 23 ? (a.id = 99) : null;
        return a;
      });
    })
    .then(response => {
      return _.uniq(response, (item) => item.id);
    });
  }

  async getStatusOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/status/list`).toPromise();
  }

  async getCompositionOptions(): Promise<any[]> {
    //return this.http.get<any>(`${API_URL}/validation/composition/list`).toPromise();
    return [
      { value: 'swir1,nir,red', label: 'SWIR1 - NIR - RED' },
      { value: 'ndvi,', label: 'NDVI' },
      { value: 'red,green,blue', label: 'Cor Verdadeira' }
    ];
  }

  async getSatelliteOptions(): Promise<any[]> {
    /* return this.http.get<any>(`${API_URL}/validation/satellite/list`).pipe(
      map(response => {
        const response2: any[] = [];
        Object.keys(response).forEach(type => {
          response[type].forEach((sensor: string) => {
            response2.push({
              type,
              sensor
            });
          });
        });
        return response2;
      })
    ).toPromise(); */
    return [
      //{ value: 'optico', type: 'optico', label: 'Óticos', level: 0 },
      { value: 'L8', type: 'optico', label: 'Landsat - 8', level: 1 },
      { value: 'S2', type: 'optico', label: 'Sentinel - 2', level: 1 },
      //{ value: 'S1', type: 'radar', label: 'Radar', level: 0 },
      { value: 'S1', type: 'radar', label: 'Sentinel - 1(SAR)', level: 1 },
    ];
  }

  /**
   * Gets alert detetection classes options
   */
  async getDataLayerOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/alert/datalayers/list/`).toPromise();
  }

  /**
   * Gets sources options
   */
  async getSourcesOptions(params: AlertsValidationFilter): Promise<any[]> {
    /* const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.sourceList;
    return this.http.post<any>(`${API_URL}/alert/source/list`, filterPayload).toPromise(); */
    return [];
  }

  async getHasEmbargoedAreasOptions(params: AlertsValidationFilter): Promise<any[]> {
    /* const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.embargoed;
    return this.http.post<any>(`${API_URL}/alert/embargoed/list`, filterPayload).toPromise(); */
    return [];
  }

  /**
   * Gets has car options
   */
  async getHasCarOptions(params: AlertsValidationFilter): Promise<any[]> {
    // const filterPayload = formatVisualizationFilterPayload(params);
    // return this.http.post<any>(`${API_URL}/alert/car/list`, filterPayload).toPromise();
    return [];
  }

  async getSizeRangeOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/alert/sizerange/list`).toPromise();
  }
}

